import {Component, Injector, OnInit, ViewEncapsulation} from '@angular/core';
import {environment} from 'src/environments/environment';
import {FormBuilder, FormGroup, Validators} from '@angular/forms';
import {ReturnUrlService} from "../../_services/return-url.service";
import {DEFAULT_LANGUAGE, JWT_TOKEN_KEY, STORAGE_LANG_KEY} from "../../_constants/common.constant";
import {JwtHelperService} from "@auth0/angular-jwt";
import {BaseComponentDirective} from "../../_shared/base/base.component";

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class LoginComponent extends BaseComponentDirective implements OnInit {
  submitted = false;
  profile: any;
  private isAuth = false;
  form: FormGroup = this.formBuilder.group({
    email: ['', [Validators.required, Validators.email]],
    password: ['', [Validators.required]],
  });
  typePassword = true;

  constructor(
    injector: Injector,
    private jwtHelper: JwtHelperService,
    private returnUrlService: ReturnUrlService,
    private formBuilder: FormBuilder,
  ) {
    super(injector);
  }

  override ngOnInit(): void {
    this.isAuth = !this.jwtHelper.isTokenExpired();
    this.profileMsg.currentMessage.subscribe(r => {
      if(r) {
        this.profile = r;
      } else {
        this.authService.profile().then(rx => {
          this.profileMsg.changeMessage(rx);
          this.profile = r;
        }, _ => {
          localStorage.clear();
        })
      }

    })
    if (this.isAuth) {
      this.returnUrlService.navigateToReturnUrlOrDefault('/subscription-check');
    } else {
      localStorage.clear();
      localStorage.setItem(STORAGE_LANG_KEY, DEFAULT_LANGUAGE);

    }
  }

  onSubmit(): void {
    this.submitted = true;

    if (this.form.invalid) {
      return;
    }

    this.form.disable();
    const { email, password } = this.form.value;
    this.authService.login(email.toLowerCase(), password).then((data) => {
          localStorage.setItem(JWT_TOKEN_KEY, data.token);
          this.currentUser();
        this.submitted = false;
      }, (err) => {
        if(err.error.status == 400 || err.error.status == 401) {
          this.showAlert('Sign In Error', err.error.description, '');
        }
        this.form.enable();
        this.submitted = false;
      },
    );
  }

  currentUser(): void {
    this.authService.profile().then(res => {
          this.profile = res;
          this.profileMsg.changeMessage(res);
          this.router.navigate(['subscription-check']).then()
        });
  }

  goHome(): void {
    document.location.href = environment.home + '/#/dashboard';
  }
}
